export default __webpack_public_path__ + "static/media/map2.ab4716f4.png";